export const ROOT_URL = 'https://api.zhitiaox.com';
export const accessId = 'LTAIgsXf1qhhbpmK';
export const signature = '4KHs5DL/9/RuW2wEcToDaGYxCB8=';
export const policy =
  'eyJleHBpcmF0aW9uIjoiMjAyMC0xMi0wMVQxMjowMDowMC4wMDBaIiwiY29uZGl0aW9ucyI6W1sic3RhcnRzLXdpdGgiLCIka2V5IiwiIl0seyJidWNrZXQiOiJ4anRsdXdhbGwtaW1hZ2UifSxbInN0YXJ0cy13aXRoIiwiJENvbnRlbnQtVHlwZSIsIiJdLFsiY29udGVudC1sZW5ndGgtcmFuZ2UiLDAsMTA0ODU3NjBdXX0=';
export const version = '1.6.5';
export const OSSaccessKey = 'LTAI5t7CQBEAL6XGQUYaz6p6';
export const OSSsecretKey = 'aKRU6uTQhSEP6PfiE5AxHMiOrP30D4';
export const bucket = 'zhitiaocdn';